export const SUCCESS_CODE = 1000;
export const DUPLICATE_USER_EMAIL = 1001;
export const DUPLICATE_USER_PHONE = 1002;
export const INVALID_LOGIN_INFO = 2001;
export const INVALID_PASSWORD = 2002;
export const INVALID_JWT_TOKEN = 2003;
export const NO_SUCH_USER = 3001;
export const JWT_TOKEN_EXPIRED = 4001;
export const DEACTIVATED_USER = 2003;
